// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1528":"c718bf02c0f70985","2806":"19695ec8036a890a","6297":"f8f05bcee9207ced","7012":"03f71c3ae041febd","8066":"108534adaf4d2235","8922":"ddfba8b352844c5b","9207":"e4dec968a37d0997"}[chunkId] + ".js";
};